/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Client_LeadInputs */

const en_features_client_lead = /** @type {(inputs: Features_Client_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every client on one page.`)
};

const pl_features_client_lead = /** @type {(inputs: Features_Client_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy podopieczny na jednej stronie.`)
};

/**
* | output |
* | --- |
* | "Every client on one page." |
*
* @param {Features_Client_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_client_lead = /** @type {((inputs?: Features_Client_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Client_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_client_lead(inputs)
	return en_features_client_lead(inputs)
});